// extracted by mini-css-extract-plugin
export default {"background_container":"LandingPage_background_container__aWd2W","background_union_image":"LandingPage_background_union_image__p6GxV"};